/**
 * Pure helpers for the Stripe contract-charge flow, factored out of the hook and
 * the Payment Element so the security-critical logic is unit-testable without a
 * DOM: the SEC-2 in-flight marker and the SEC-8 "advance only on succeeded" gate.
 */

const INFLIGHT_PREFIX = "stripe-charge-inflight-";

export const inflightKey = (contractId) => `${INFLIGHT_PREFIX}${contractId}`;

export const markInflight = (contractId) => {
  if (contractId != null) {
    sessionStorage.setItem(inflightKey(contractId), "1");
  }
};

export const clearInflight = (contractId) => {
  if (contractId != null) {
    sessionStorage.removeItem(inflightKey(contractId));
  }
};

export const isInflight = (contractId) =>
  contractId != null && sessionStorage.getItem(inflightKey(contractId)) === "1";

/**
 * SEC-8: a charge/setup may only advance contract status when the payer's money
 * is genuinely committed. That means `succeeded` for a contract charged outright,
 * and `requires_capture` for one held until the gigster accepts — the card has
 * been authorized and the funds are reserved, the capture just happens later.
 * Any other status (canceled, other requires_*, processing) or a missing intent
 * must NOT advance.
 */
const COMMITTED_INTENT_STATUSES = ["succeeded", "requires_capture"];

export const isIntentSucceeded = (result) => {
  const intent = result?.paymentIntent || result?.setupIntent;
  return COMMITTED_INTENT_STATUSES.includes(intent?.status);
};

/**
 * Connect onboarding poll decision: stop once payouts are enabled or the bounded
 * attempt cap is reached. Kept pure so the bounded-poll logic is unit-testable
 * independently of timers.
 */
export const shouldStopPolling = (status, count, max) =>
  Boolean(status?.payouts_enabled) || count >= max;
